/* Copyright (c) 2020-present CloudIO Inc */

// Copy this file to src/componentregistry/components/Accordion folder
// and import helpRenders into AccordionManager.ts file
// import { helpRenders } from './Accordion_Help';

import { ComponentSample, Item } from 'componentregistry';

const page: {
  root: Item<'Page'>;
  boxContainer: Item<'BoxContainer'>;
  accordion: Item<'Accordion'>;
  accordion1: Item<'Accordion'>;
  localDataStore: Item<'LocalDataStore'>;
  dataStoreReference: Item<'DataStoreReference'>;
  form: Item<'Form'>;
  numberField: Item<'NumberField'>;
  textField: Item<'TextField'>;
  numberField1: Item<'NumberField'>;
  dateField: Item<'DateField'>;
  checkbox: Item<'Checkbox'>;
  checkbox1: Item<'Checkbox'>;
  numberField2: Item<'NumberField'>;
  textField3: Item<'TextField'>;
  numberField3: Item<'NumberField'>;
  dateField3: Item<'DateField'>;
  checkbox2: Item<'Checkbox'>;
  checkbox3: Item<'Checkbox'>;
  form1: Item<'Form'>;
  dataStoreReference1: Item<'DataStoreReference'>;
} = {
  accordion: {
    children: ['dataStoreReference'],
    itemId: 'accordion',
    parent: 'boxContainer',
    props: {
      subTitle: 'Sub Title',
      title: 'Header One',
    },
    type: 'Accordion',
  },
  accordion1: {
    children: ['dataStoreReference1'],
    itemId: 'accordion1',
    parent: 'boxContainer',
    props: {
      expanded: false,
      subTitle: 'Sub title...',
      title: 'Header Two',
    },
    type: 'Accordion',
  },
  boxContainer: {
    children: ['accordion', 'accordion1'],
    itemId: 'boxContainer',
    parent: 'root',
    props: {
      alignItems: 'flex-start',
      boxHeight: '100%',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      overflow: 'scroll',
    },
    type: 'BoxContainer',
  },
  checkbox: {
    children: [],
    itemId: 'checkbox',
    parent: 'form',
    props: {
      label: { type: 'text', value: 'Boolean' },
      viewAttribute: 'boolean',
    },
    type: 'Checkbox',
  },
  checkbox1: {
    children: [],
    itemId: 'checkbox1',
    parent: 'form',
    props: {
      label: { type: 'text', value: 'Checkbox' },
      viewAttribute: 'checkbox',
    },
    type: 'Checkbox',
  },
  checkbox2: {
    children: [],
    itemId: 'checkbox2',
    parent: 'form1',
    props: {
      label: { type: 'text', value: 'Boolean' },
      viewAttribute: 'boolean',
    },
    type: 'Checkbox',
  },
  checkbox3: {
    children: [],
    itemId: 'checkbox3',
    parent: 'form1',
    props: {
      label: { type: 'text', value: 'Checkbox' },
      viewAttribute: 'checkbox',
    },
    type: 'Checkbox',
  },
  dataStoreReference: {
    children: ['form'],
    itemId: 'dataStoreReference',
    parent: 'accordion',
    props: {
      alias: 'testAlias',
    },
    type: 'DataStoreReference',
  },
  dataStoreReference1: {
    children: ['form1'],
    itemId: 'dataStoreReference1',
    parent: 'accordion1',
    props: {
      alias: 'testAlias',
    },
    type: 'DataStoreReference',
  },
  dateField: {
    children: [],
    itemId: 'dateField',
    parent: 'form',
    props: {
      label: { type: 'text', value: 'Date Time' },
      showTime: true,
      viewAttribute: 'dateTime',
    },
    type: 'DateField',
  },
  dateField3: {
    children: [],
    itemId: 'dateField3',
    parent: 'form1',
    props: {
      label: { type: 'text', value: 'Date Time' },
      showTime: true,
      viewAttribute: 'dateTime',
    },
    type: 'DateField',
  },
  form: {
    children: [
      'numberField',
      'textField',
      'numberField1',
      'dateField',
      'checkbox',
      'checkbox1',
    ],
    itemId: 'form',
    parent: 'dataStoreReference',
    props: {},
    type: 'Form',
  },
  form1: {
    children: [
      'numberField2',
      'textField3',
      'numberField3',
      'dateField3',
      'checkbox2',
      'checkbox3',
    ],
    itemId: 'form1',
    parent: 'dataStoreReference1',
    props: {},
    type: 'Form',
  },
  localDataStore: {
    children: [],
    itemId: 'localDataStore',
    parent: 'root',
    props: {
      alias: 'testAlias',
      dataFormat: 'json',
      dataSource: 'test',
      jsonData:
        '[\n    {\n        "firstName": "John",\n        "number": 123.456,\n        "dateTime": "2022-02-02T22:10:09.276Z",\n        "boolean": true,\n        "checkbox": "Y"\n    }\n]',
    },
    type: 'LocalDataStore',
  },
  numberField: {
    children: [],
    itemId: 'numberField',
    parent: 'form',
    props: {
      allowDecimal: false,
      label: { type: 'text', value: 'Id' },
      updatable: {
        type: 'boolean',
        value: false,
      },
      viewAttribute: 'id',
    },
    type: 'NumberField',
  },
  numberField1: {
    children: [],
    itemId: 'numberField1',
    parent: 'form',
    props: {
      label: { type: 'text', value: 'Number' },
      viewAttribute: 'number',
    },
    type: 'NumberField',
  },
  numberField2: {
    children: [],
    itemId: 'numberField2',
    parent: 'form1',
    props: {
      allowDecimal: false,
      label: { type: 'text', value: 'Id' },
      updatable: {
        type: 'boolean',
        value: false,
      },
      viewAttribute: 'id',
    },
    type: 'NumberField',
  },
  numberField3: {
    children: [],
    itemId: 'numberField3',
    parent: 'form1',
    props: {
      label: { type: 'text', value: 'Number' },
      viewAttribute: 'number',
    },
    type: 'NumberField',
  },
  root: {
    children: ['localDataStore', 'boxContainer'],
    itemId: 'root',
    parent: 'root',
    props: {
      backgroundColor: 'default',
      windowTitle: {
        type: 'text',
        value: 'Blank Page',
      },
    },
    type: 'Page',
  },
  textField: {
    children: [],
    itemId: 'textField',
    parent: 'form',
    props: {
      label: { type: 'text', value: 'First Name' },
      viewAttribute: 'firstName',
    },
    type: 'TextField',
  },
  textField3: {
    children: [],
    itemId: 'textField3',
    parent: 'form1',
    props: {
      label: { type: 'text', value: 'First Name' },
      viewAttribute: 'firstName',
    },
    type: 'TextField',
  },
};

export const helpRenders: ComponentSample<'Accordion'>[] = [
  {
    title: 'Accordion',
    description: '',
    page,
    exampleId: 'eg1',
    clearParentChildren: false,
    height: 380,
    visibleProps: ['expanded', 'title', 'subTitle'],
    item: {
      itemId: 'accordion',
      type: 'Accordion',
      children: ['dataStoreReference'],
      parent: 'boxContainer',
      props: {
        title: 'Header One',
        subTitle:
          'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
      },
    },
  },
];
